'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CalendarManager = undefined;

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _arrayTo = require('d2-utilizr/lib/arrayTo');

var _arrayTo2 = _interopRequireDefault(_arrayTo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CalendarManager = exports.CalendarManager = undefined;

exports.CalendarManager = CalendarManager = function CalendarManager(refs, config) {
    var t = this;

    config = (0, _isObject2.default)(config) ? config : {};

    // constructor
    t.baseUrl = config.baseUrl || '..';
    t.dateFormat = config.dateFormat || 'yyyy-MM-dd';
    t.defaultCalendarId = 'gregorian';
    t.defaultCalendarIsoId = 'iso8601';
    t.calendarIds = ['coptic', 'ethiopian', 'islamic', 'julian', 'nepali', 'thai', 'persian'];

    // uninitialized
    t.calendar;
    t.periodGenerator;

    // transient
    t.calendarIdMap;
};

CalendarManager.prototype.setBaseUrl = function (baseUrl) {
    this.baseUrl = baseUrl;
};

CalendarManager.prototype.setDateFormat = function (dateFormat) {
    this.dateFormat = dateFormat;
};

CalendarManager.prototype.getPeriodScriptUrl = function () {
    return this.baseUrl + '/dhis-web-commons/javascripts/dhis2/dhis2.period.js';
};

CalendarManager.prototype.getCalendarScriptUrl = function (calendarId) {
    return this.baseUrl + '/dhis-web-commons/javascripts/jQuery/calendars/jquery.calendars.' + calendarId + '.min.js';
};

CalendarManager.prototype.getCalendarIdMap = function () {
    if (this.calendarIdMap) {
        return this.calendarIdMap;
    }

    this.calendarIdMap = {};
    this.calendarIdMap[this.defaultCalendarIsoId] = this.defaultCalendarId;

    return this.calendarIdMap;
};

CalendarManager.prototype.createCalendar = function (calendarId) {
    this.calendar = $.calendars.instance(calendarId);
};

CalendarManager.prototype.createPeriodGenerator = function (calendarId) {
    this.periodGenerator = new dhis2.period.PeriodGenerator(this.calendar, this.dateFormat);
};

CalendarManager.prototype.applyTo = function (modules) {
    var t = this;

    (0, _arrayTo2.default)(modules).forEach(function (module) {
        module.calendarManager = t;
    });
};

// dep 1

CalendarManager.prototype.init = function (calendarId, dateFormat) {
    calendarId = this.getCalendarIdMap()[calendarId] || calendarId || this.defaultCalendarId;

    if (this.calendar && this.periodGenerator) {
        return;
    }

    var t = this,
        periodUrl = t.getPeriodScriptUrl(),
        success = function success() {
        t.createCalendar(calendarId);
        t.createPeriodGenerator(calendarId);
    };

    if ((0, _arrayContains2.default)(t.calendarIds, calendarId)) {
        var calendarUrl = t.getCalendarScriptUrl(calendarId);

        $.getScript(calendarUrl, function () {
            $.getScript(periodUrl, function () {
                success();
            });
        });
    } else {
        $.getScript(periodUrl, function () {
            success();
        });
    }
};
//# sourceMappingURL=CalendarManager.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/manager/CalendarManager.js
 ** module id = 130
 ** module chunks = 0 1
 **/